module.exports = __webpack_public_path__ + "assets/icon_ugc_season.svg";